import Lang from '@/modules/core/app/services/Lang';
import { FormSelectConfig } from '@/modules/core/form/models/FormSelectConfig';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import WorkflowEstateStatusService from '@/modules/workflow/services/WorkflowEstateStatusListService';
import { EstateStatus } from '/@/modules/estate/constants/EstateStatus';

export class WorkflowEstateStatusFormSelectConfig extends FormSelectConfig {
  private workflowType?: string;

  constructor(config: Params = {}) {
    const { workflowType, ...rest } = config;
    super({
      placeholder: Lang.t('core.select'),
      ...rest
    });
    this.workflowType = workflowType;
  }

  // @ts-ignore
  async getOptions(
    params: { selectedJurisdictions: Array<number>; selectedEstateTypes: Array<string> } = {
      selectedJurisdictions: [],
      selectedEstateTypes: []
    }
  ): Promise<EstateStatus[]> {
    const allOptions: EstateStatus[] = EstateStatus.getValues();

    const availableOptions: GenericModel[] = await WorkflowEstateStatusService.getEstateStatusList(
      params.selectedJurisdictions,
      params.selectedEstateTypes,
      this.workflowType
    );

    return allOptions.filter((estateStatus: EstateStatus) =>
      availableOptions.includes(estateStatus.key)
    );
  }
}
